import React from 'react';

import Icon from './index';

interface Props {
  className?: string;
}

/** IconDownload's arrow pointed up — the pair for Export / Import. */
function IconImport({ className }: Props) {
  return (
    <Icon className={className}>
      <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M9 1.5L5 5.5M9 1.5L13 5.5M9 1.5V11.5"
          stroke="#212121"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M1 15.5H17" stroke="#212121" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </Icon>
  );
}

export default React.memo(IconImport);
